import messages from "../i18n/messages";

export default {
  locale: 'de',
  fallbackLocale: 'de',
  messages,
}
